function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-four-articles-highlight\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9,26.14H15.1a1.13,1.13,0,1,1,0-2.25h9.8a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.45,31.19h-6.9a1.13,1.13,0,0,1,0-2.25h6.9a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.25,31.19H30.36a1.13,1.13,0,1,1,0-2.25h6.89a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.64,31.19H2.75a1.13,1.13,0,0,1,0-2.25H9.64a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M38.7,26.14H28.9a1.13,1.13,0,0,1,0-2.25h9.8a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1,26.14H1.3a1.13,1.13,0,1,1,0-2.25h9.8a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.2,18.9A5.83,5.83,0,1,1,12,13.07,5.84,5.84,0,0,1,6.2,18.9Zm0-9.41a3.58,3.58,0,1,0,3.58,3.58A3.58,3.58,0,0,0,6.2,9.49Z",
  fill: "#231f20"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20,18.9a5.83,5.83,0,1,1,5.83-5.83A5.84,5.84,0,0,1,20,18.9Zm0-9.41a3.58,3.58,0,1,0,3.58,3.58A3.59,3.59,0,0,0,20,9.49Z",
  fill: "#231f20"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8,18.9a5.83,5.83,0,1,1,5.83-5.83A5.84,5.84,0,0,1,33.8,18.9Zm0-9.41a3.58,3.58,0,1,0,3.58,3.58A3.59,3.59,0,0,0,33.8,9.49Z",
  fill: "#231f20"
});

function SvgCmsFourArticlesHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default SvgCmsFourArticlesHighlight;